import { Footer, TopNav } from "@civala/shared-ui"
import { Box, Button, Group, Paper, SimpleGrid, Stack, Text, Title } from "@mantine/core"
import { IconArrowUpRight } from "@tabler/icons-react"

type Entry = {
  id: string
  name: string
  tagline: string
  description: string
  href: string
}

const ENTRIES: ReadonlyArray<Entry> = [
  {
    id: "nexus",
    name: "Nexus",
    tagline: "Command Center",
    description: "Operational command center for portfolio management, agent governance, and decision workflows.",
    href: "https://nexus.civala.ai",
  },
  {
    id: "investor",
    name: "Investor",
    tagline: "LP Portal",
    description:
      "Capital accounts, QSBS tracking, milestone progress, and portfolio intelligence for limited partners.",
    href: "https://investor.civala.ai",
  },
  {
    id: "portal",
    name: "AI Portal",
    tagline: "Capabilities Catalog",
    description: "Explore the AI capabilities available in Claude Desktop — agents, skills, and data sources.",
    href: "https://portal.civala.ai",
  },
]

export function App() {
  return (
    <Box mih="100vh" bg="var(--pitch-surface)">
      <TopNav navItems={[]} brandHref="/" />

      <Box bg="var(--pitch-page-dark)" py={96}>
        <Box maw={1280} mx="auto" px="lg" ta="center">
          <Text fz={11} lts="0.18em" tt="uppercase" fw={600} c="var(--pitch-accent)" mb={20}>
            Civala
          </Text>
          <Title
            order={1}
            ff="'Playfair Display', Georgia, serif"
            fz="clamp(32px, 4vw, 56px)"
            lh={1.15}
            fw={500}
            c="white"
            maw={880}
            mx="auto"
            style={{ letterSpacing: "-0.005em" }}
          >
            A federation of biotech companies purpose-built for institutional capital.
          </Title>
          <Text fz={15} lh={1.6} mt={24} c="rgba(255,255,255,0.72)" maw={680} mx="auto">
            Three surfaces, one operating system. Sign in to continue.
          </Text>
        </Box>
      </Box>

      <Box bg="var(--pitch-surface)" py={64}>
        <Box maw={1280} mx="auto" px="lg">
          <SimpleGrid cols={{ base: 1, md: 3 }} spacing="lg">
            {ENTRIES.map((e) => (
              <Paper
                key={e.id}
                p="xl"
                radius="xs"
                withBorder
                style={{
                  borderColor: "var(--pitch-border)",
                  background: "var(--pitch-surface)",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Stack gap="md" style={{ flex: 1 }}>
                  <Stack gap={4}>
                    <Text fz={11} lts="0.12em" tt="uppercase" fw={600} c="var(--pitch-accent)">
                      {e.tagline}
                    </Text>
                    <Text
                      ff="'Playfair Display', Georgia, serif"
                      fz={28}
                      fw={500}
                      lh={1.2}
                      c="var(--pitch-text-primary)"
                    >
                      {e.name}
                    </Text>
                  </Stack>
                  <Text fz={14} lh={1.6} c="var(--pitch-text-secondary)">
                    {e.description}
                  </Text>
                  <Group justify="flex-end" mt="auto" pt="md">
                    <Button
                      component="a"
                      href={e.href}
                      color="pitchNavy"
                      rightSection={<IconArrowUpRight size={16} stroke={1.8} />}
                      radius="xs"
                    >
                      Sign In
                    </Button>
                  </Group>
                </Stack>
              </Paper>
            ))}
          </SimpleGrid>
        </Box>
      </Box>

      <Footer
        navItems={[
          { id: "nexus", label: "Nexus", href: "https://nexus.civala.ai" },
          { id: "investor", label: "Investor", href: "https://investor.civala.ai" },
          { id: "portal", label: "AI Portal", href: "https://portal.civala.ai" },
        ]}
        tagline="A federation of biotech companies purpose-built for institutional capital."
        relatedItems={["Nexus Command Center", "Investor LP Portal", "AI Capabilities Portal"]}
      />
    </Box>
  )
}
